import React from 'react';
import { SurveyPieCard, SurveyPieCategory } from './SurveyPieCard';
import { WellnessResponse } from '../../../shared/constants';
import {
  customError,
  customSuccess,
  lightTeal,
  orange,
  warningYellow,
} from '../../../mainTheme';

// `type` (not `interface`) so it satisfies SurveyPieCard's Record<string, number>.
export type WellnessData = {
  veryBad: number;
  bad: number;
  neutral: number;
  good: number;
  veryGood: number;
};

interface WellnessCardProps {
  isSelected?: boolean;
  onClick?: () => void;
  data: WellnessData;
}

// Daily wellness check buckets (1-5), lowest → highest. Colors match the
// wellness SurveyResponseChip on Patient → Overview.
export const WELLNESS_CATEGORIES: SurveyPieCategory[] = [
  { name: WellnessResponse.VeryBad, key: 'veryBad', color: customError },
  { name: WellnessResponse.Bad, key: 'bad', color: orange },
  { name: WellnessResponse.Neutral, key: 'neutral', color: warningYellow },
  { name: WellnessResponse.Good, key: 'good', color: lightTeal },
  { name: WellnessResponse.VeryGood, key: 'veryGood', color: customSuccess },
];

export const WellnessCard: React.FC<WellnessCardProps> = ({
  isSelected,
  onClick,
  data,
}) => (
  <SurveyPieCard
    title="Wellness"
    categories={WELLNESS_CATEGORIES}
    data={data}
    isSelected={isSelected}
    onClick={onClick}
    testId="wellness-card"
  />
);
